import { render, staticRenderFns } from "./WrkSubAgentAdd.vue?vue&type=template&id=5c1d8354&scoped=true"
import script from "./WrkSubAgentAdd.vue?vue&type=script&lang=js"
export * from "./WrkSubAgentAdd.vue?vue&type=script&lang=js"
import style0 from "./WrkSubAgentAdd.vue?vue&type=style&index=0&id=5c1d8354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d8354",
  null
  
)

export default component.exports